import { R as a, E as e, k as i, l as c } from "./export-cdcbfb2b.js";
import { i as u } from "./es.object.to-string-f55666a8.js";
var v = u, l = a, f = TypeError, p = function(r) {
  if (v(r))
    return r;
  throw new f(l(r) + " is not a constructor");
}, t = i, C = p, S = c, $ = e, d = $("species"), E = function(r, s) {
  var o = t(r).constructor, n;
  return o === void 0 || S(n = t(o)[d]) ? s : C(n);
};
export {
  E as s
};
